import { render, staticRenderFns } from "./View10.vue?vue&type=template&id=d38eb03c"
import script from "./View10.vue?vue&type=script&lang=js"
export * from "./View10.vue?vue&type=script&lang=js"
import style0 from "./View10.vue?vue&type=style&index=0&id=d38eb03c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports